import { ref, Ref } from 'vue'

const isDisplayInsurancePopup: Ref<boolean> = ref(false)

export default isDisplayInsurancePopup
